import type { InstallableSoftwareQuery } from './type';

export const softwareLibraryKey = {
  all: ['software-library'] as const,
  suggest: () => [...softwareLibraryKey.all, 'suggest'] as const,
  categories: () => [...softwareLibraryKey.all, 'categories'] as const,
  lists: () => [...softwareLibraryKey.all, 'list'] as const,
  list: (params: InstallableSoftwareQuery) =>
    [...softwareLibraryKey.lists(), params] as const,
  appDetails: () => [...softwareLibraryKey.all, 'app-detail'] as const,
  appDetail: (appId: string) =>
    [...softwareLibraryKey.appDetails(), appId] as const,
  details: () => [...softwareLibraryKey.all, 'detail'] as const,
  detail: (softwareLibraryId: string) =>
    [...softwareLibraryKey.details(), softwareLibraryId] as const,
} as const;
